import React, { useState } from 'react';
import ScrollReactTable from 'components/shared/ScrollReactTable/ScrollReactTable';
import moment from 'moment';
import SvgAF, { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import { reactTableSortOnClickInFuncComp } from 'common/utils/helpers';
import classNames from 'classnames';
import styles from './BeamTablesManagerTable.module.css';

export const BeamTablesManagerTable = (props) => {
  const { fetching, beamTablesData, parent, error } = props;

  const [sorted, setSorted] = useState([{ id: 'uploaded_on', desc: true }]);

  let overlay = null;
  if (error && (beamTablesData == null || beamTablesData.length === 0)) {
    overlay = (
      <div className="Global_Table_ErrorOverlay">
        <div className="Global_Table_Error_Div">
          <div className="Global_Table_ErrorOverlay_Title">Error </div>
          <div className="Global_Table_ErrorOverlay_Message">
            An unexpected problem occurred and this data is unavailable. Please try refreshing the page, and if the
            problem persists, contact us at
            <a href="mailto:support@pivotalcommware.com"> support@pivotalcommware.com</a>
          </div>
        </div>
      </div>
    );
  }

  const columns = (parent) => [
    {
      Header: (col) => {
        return (
          <div className={styles.header}>
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={'Version'}
              reverse
              onClick={() => reactTableSortOnClickInFuncComp(sorted, setSorted, 'version')}
            />
            <div className={styles.slider}>
              <div className={styles.sliderBar}></div>
            </div>
          </div>
        );
      },
      id: 'version',
      minWidth: 90,
      accessor: (beamTable) => {
        return beamTable.version;
      },
      Cell: (row) => {
        const version = row.value;
        return (
          <div className={styles.cell} data-tip={version}>
            <span>{version}</span>
          </div>
        );
      },
      sortMethod: (a, b) => {
        return a.toLowerCase() > b.toLowerCase() ? 1 : -1;
      }
    },
    {
      Header: (col) => {
        return (
          <div className={styles.header}>
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={'Frequency Band'}
              reverse
              onClick={() => reactTableSortOnClickInFuncComp(sorted, setSorted, 'freqband')}
            />
            <div className={styles.slider}>
              <div className={styles.sliderBar}></div>
            </div>
          </div>
        );
      },
      id: 'freqband',
      minWidth: 110,
      accessor: (beamTable) => {
        return beamTable.freqband || 'N/A';
      },
      Cell: (row) => {
        const freqband = row.value;
        return (
          <div className={styles.cell} data-tip={freqband}>
            <span>{freqband}</span>
          </div>
        );
      },
      sortMethod: (a, b) => {
        return a.toLowerCase() > b.toLowerCase() ? 1 : -1;
      }
    },
    {
      Header: (col) => {
        return (
          <div className={styles.header}>
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={'Uploaded on'}
              reverse
              onClick={() => reactTableSortOnClickInFuncComp(sorted, setSorted, 'uploaded_on')}
            />
            <div className={styles.slider}>
              <div className={styles.sliderBar}></div>
            </div>
          </div>
        );
      },
      id: 'uploaded_on',
      minWidth: 120,
      accessor: (beamTable) => {
        return beamTable.uploadedOn;
      },
      Cell: (row) => {
        const uploadedOn = moment(row.value).format('MMM D, YYYY, h:mm a');
        return (
          <div className={styles.cell} data-tip={uploadedOn}>
            {uploadedOn}
          </div>
        );
      },
      sortMethod: (a, b) => {
        return a > b ? 1 : -1;
      }
    },
    {
      Header: (col) => {
        return (
          <div className={styles.header}>
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={'File Name'}
              reverse
              onClick={() => reactTableSortOnClickInFuncComp(sorted, setSorted, 'filename')}
            />
          </div>
        );
      },
      id: 'filename',
      minWidth: 180,
      accessor: (beamTable) => {
        return beamTable.filename;
      },
      Cell: (row) => {
        const filename = row.value;
        return (
          <div className={styles.cell} data-tip={filename}>
            <span>{filename}</span>
          </div>
        );
      },
      sortMethod: (a, b) => {
        return a > b ? 1 : -1;
      }
    },
    {
      id: 'delete_beam_table',
      accessor: 'delete_beam_table',
      sortable: false,
      maxWidth: 40,
      resizable: false,
      Cell: (row) => {
        const { beamtableID, version } = row.original;
        return (
          <div
            className={classNames({
              [styles.actionCell]: true,
              [styles.ellipsisBtn]: true
            })}
          >
            {parent.state.deleteSWPermissions ? (
              <SvgAF
                img={IconLoader.icon_delete_button_default}
                hover={IconLoader.icon_delete_button_hover}
                tooltip={'Delete this beam table'}
                onClick={() => {
                  if (beamtableID != null) {
                    parent.setState({
                      deleteBeamTableModalOpen: true,
                      deleteBeamTableId: beamtableID,
                      deleteBeamTableVersion: version,
                      deleteBeamTableFailed: false,
                      deleteBeamTablePending: false
                    });
                  }
                }}
              />
            ) : (
              <SvgAF img={IconLoader.icon_delete_button_disabled} tooltip={'No permission to delete beam table'} />
            )}
          </div>
        );
      }
    }
  ];

  return (
    <ScrollReactTable
      className={classNames({
        Global_Table: true,
        [styles.table]: true
      })}
      showPagination={false}
      minRows={13}
      fetching={fetching}
      overlay={overlay}
      noDataText={''}
      pageSize={beamTablesData.length}
      data={beamTablesData}
      columns={columns(parent)}
      sorted={sorted}
      onSortedChange={(newSorted) => {
        setSorted(newSorted);
      }}
    />
  );
};
